import React, { useState, useEffect } from 'react';

function FloatingTooltip({ isVisible, onFirstClick }) {
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
    const [hasClicked, setHasClicked] = useState(false);

    useEffect(() => {
        const handleMouseMove = (e) => {
            setMousePosition({ x: e.clientX, y: e.clientY });
        };

        const handleClick = () => {
            if (!hasClicked && isVisible) {
                setHasClicked(true);
                onFirstClick();
            }
        };

        if (isVisible && !hasClicked) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('click', handleClick);
        }

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('click', handleClick);
        };
    }, [isVisible, hasClicked, onFirstClick]);

    if (!isVisible || hasClicked) return null;

    return (
        <div
            style={{
                position: 'fixed',
                left: mousePosition.x + 15,
                top: mousePosition.y - 35,
                color: 'white',
                padding: '8px 16px',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '500',
                pointerEvents: 'none',
                zIndex: 10000,
                whiteSpace: 'nowrap',
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
            }}
        >
            <div
                style={{
                    width: '8px',
                    height: '8px',
                    background: '#00FFA3',
                    borderRadius: '50%',
                    animation: 'dotPulse 2s ease-in-out infinite'
                }}
            />
            <span>Press V to enter view mode</span>
            <style>
                {`
                    @keyframes dotPulse {
                        0%, 100% { 
                            opacity: 0.6;
                            transform: scale(1);
                        }
                        50% { 
                            opacity: 1;
                            transform: scale(1.2);
                        }
                    }
                `}
            </style>
        </div>
    );
}

export default FloatingTooltip;